<!--==============================
=            TOSOLIST            =
===============================-->
<template>
<div>
<v-row>  <create-todo @on-new-todo="addTodo($event)" /></v-row>
<v-row>  <v-col cols="12"
             md="12" sm="12"><todo
            v-for="(todo, index) in todos"
            :key="index"
            :description="todo.description"
            :completed="todo.completed"
            @on-toggle="toggleTodo(todo)"
            @on-delete="deleteTodo(todo)"
            @on-edit="editTodo(todo, $event)"
          /></v-col></v-row>
</div>

</template>


<script>
import Todo from "./Todo.vue";
import CreateTodo from "./CreateTodo.vue";

export default {
  props: {
    listName: String,
  },
  data() {
    return {
      todos: [
        { description: "Do the dishes", completed: false },
        { description: "Take out the trash", completed: false },
        { description: "Finish doing laundry", completed: false },
         { description: "Finish doing laundry", completed: false },
          { description: "Finish doing laundry", completed: false },
           { description: "Finish doing laundry", completed: false },{ description: "Finish doing laundry", completed: false },
      ],
    };
  },
  methods: {
    addTodo(newTodo) {
      this.todos.push({ description: newTodo, completed: false });
    },
    toggleTodo(todo) {
      todo.completed = !todo.completed;
    },
    deleteTodo(deletedTodo) {
      this.todos = this.todos.filter(todo => todo !== deletedTodo);
    },
    editTodo(todo, newTodoDescription) {
      todo.description = newTodoDescription;
    },
  },
  components: { Todo, CreateTodo },
};
</script>


<!--====  End of TOSOLIST  ====-->
